import styled from 'styled-components';

const ReportResultsTitleBar = styled.div`
  background-color: ${(props): string => props.theme.colors.paleBlue};
  padding: ${(props): string =>
    `${props.theme.spaces.md} ${props.theme.spaces.xl}`};

  align-items: center;

  display: grid;
  grid-template-columns: 1fr auto auto;
  grid-column-gap: ${(props): string => props.theme.spaces.xl};
`;

export { ReportResultsTitleBar };
